import { gql } from '@apollo/client';
import { registerFragment } from '@redwoodjs/web/apollo';

/**
 * Lot fields consumed by tag editing and printing, also needed before those tabs open. Registered here,
 * beside the pallet-tag read: the receiving drawer loads without the lots module, and the lot page's
 * `LOT_CORE_QUERY` reaches this registration through the re-export in `lots/queries/lotQueries.ts`.
 */
const LOT_PRINTER_FIELDS = gql`
  fragment LotPrinterFields on Lot {
    id
    slug
    status
    quantity
    weight
    receiveDate
    warehouseId
    initialQuantity
    initialWeight
    receivedByWeight
    weightPerInventoryUnit
    lotSupplierSources {
      businessEntity { id name }
      place { id description }
      type
    }
    fieldTicketIds
    harvestLocations
    product { ...ProductAttributes }
    productionRunComponents {
      id
      createdAt
      type
      productionRun { id slug startedAt completedAt }
    }
  }
`;

registerFragment(LOT_PRINTER_FIELDS);

/** A lot's pallet tags with its tag layouts: the lot page's pallet-tags section and the receiving pallet-tag drawer. */
export const LOT_PALLET_TAGS_QUERY = gql`
  query LotPalletTagsQuery($slug: String!, $warehouseId: Int!) {
    lot(slug: $slug, warehouseId: $warehouseId) {
      ...LotPrinterFields
      warehouse { id }
      palletTags {
        ...PalletTagAttributes
        salesOrders { id slug status }
      }
    }
    tagLayoutPage(input: { first: 50, sortItems: [{ field: "id", sort: "asc" }] }) {
      edges { node { id name schema isLastUsed } }
    }
  }
`;
